<template>
  <b-row>
    <b-col class="pt-4 pl-0 pr-0">
      <carousel
        :perPageCustom="[
          [320, 2],
          [799, 3],
          [999, 5],
          
        ]"
        :paginationEnabled="false"
        :paginationPadding="8"
        :paginationActiveColor="paginationColor"
        :speed="500"
        :spacePadding="20"
        style="width: 100%"
      >
        <slide
          class="skinselectorslide"
          style="width:100px! background-color:red"
          v-for="(item, index) in getskinskulist()"
          :key="index"
          @click="clicksku(index)"
        >
          <b-row>
            <b-col>
              <b-row :style="[item.color? {'background-color': item.color}:{'background-color': 'gray'}]" style='height:60px; border-radius: 10px 10px 0px 0px; '> 

              </b-row>
              <b-row style='background-color:#F2F3F3'>
                <b-col >
                <b-img
                  :src="item.images[1]"
                  fluid
                  center
                  style='margin-top:-35px; width:80px!important; height:80px; margin-left:auto!important; margin-right:auto!important'
                  class="inactiveskuskin swatch-thumbnail"
                ></b-img>
                </b-col>
              </b-row>
              <b-row style='background-color:#F2F3F3' class='pt-2'>
                <b-col style='text-align:center;font-size:18px;'>
                {{item.attributes.Style}}
                </b-col>
              </b-row>
              <b-row
                class="pt-0 pb-3 pl-3 reduced_pl_pr"
                v-if="
                  getDiscountSkinPrice(false, item) - getDiscountSkinPrice(true, item) >
                  0.000001
                "
                style='background-color:#F2F3F3; justify-content:center'
              >
                <span class="">
                  <b class="price_text">
                    ${{ getDiscountSkinPrice(true, item) }}
                  </b>
                  <strike class="price_text">(was ${{ getDiscountSkinPrice(false, item) }})</strike>
                </span>
              </b-row>
              <b-row class="pt-0 pb-3 pl-0 reduced_pl_pr" v-else style='background-color:#F2F3F3; justify-content:center'>
                <span class="pl-0">
                  <b class="price_text">
                    ${{ getDiscountSkinPrice(false, item) }}
                  </b>
                </span>
              </b-row>
              <b-row class="pt-2 pb-5 pl reduced_pl_pr" style='background-color:#F2F3F3; border-radius: 0px 0px 10px 10px;'>
                <b-col>
                    <b-button
                    pill
                    class="full-width blue-button"
                    style='height: 33px;'
                    v-on:click="onAddCartSkin(item)"
                  >
                    <span class='price_text'>Add Cart</span>
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </slide>
      </carousel>
    </b-col>
          <b-row>
        <Checkout-Express id="my-modal" ref="my-modal"> </Checkout-Express>
      </b-row>
  </b-row>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import store from "../store";
import storage from "../storage";
import CheckoutExpress from "./../components/CheckoutExpress";
export default {
  name: "SkinSelector",
  components: {
    Carousel,
    Slide,
    CheckoutExpress,
  },
  data: function () {
    return {
      paginationColor: "#12B8ED",
      parent_page: null,
    };
  },
  methods: {
    getskinskulist() {
      return store.state.inventory.skin;
    },
    getDiscountSkinPrice(dis, item) {
      var sku = item
      if (sku == null) return 4.99;
      var price = sku.price;
      if (dis) {
        var off = store.state.discount_percent;
        var price_discounted = price - price * off;
        return (price_discounted / 100).toFixed(2);
      } else {
        return (price / 100).toFixed(2);
      }
    },
    onAddCartSkin(sku) {
      sku.productid = "prod_0000";
      var list = [];
      sku.metadata = {};
      sku.metadata.image0 = sku.images[0];
      list.push({ sku: sku, quantity: 1 });
      storage.onAddCart(list, this.parent_page);
    },
    updateParent(parent){
      this.parent_page = parent;
    }
    
  },
};
</script>

<style lang="scss">
@media (max-width: 768px) {
  .review-stars {
    width: 18px !important;
    margin-right: 1px !important;
  }
}

.price_text{
  font-size:18px;
}

@media (max-width: 768px) {
  .price_text{
  font-size:14px!important;
}
.skinselectorslide .col{
  padding-left: 5px;
  padding-right: 5px;
}
}

</style>
